import Vue from 'vue';
import store from '../../store';
import recipeIngredienceTransformer from '../../transformers/recipeIngredience';

const success = ({ data }, resolve) => {
  const recipeIngrediences = recipeIngredienceTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllMaterials', recipeIngrediences);
  resolve(recipeIngrediences);
};

const failed = () => {};


export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('/production/recipe_ingredience')
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/recipeIngredience/all.js